// extracted by mini-css-extract-plugin
export var attachmentContainer = "_ik-0";
export var fileList = "_ik-2";
export var removeFileButton = "_ik-1";